import { FC } from 'react';
import { IconBaseProps, IconType } from 'react-icons';

/**
 * react-icons v5 declares an icon as `(props) => ReactNode`, but React 18's JSX requires a component
 * to return `ReactElement | null`, so an icon cannot be rendered without being re-typed first.
 *
 * Doing that here once keeps each icon's own props (className, size, color, title) type-checked at
 * every usage - which the per-icon `as any` this replaces had thrown away.
 */
export const asIcon = (icon: IconType): FC<IconBaseProps> =>
  icon as unknown as FC<IconBaseProps>;
